module.exports = __webpack_public_path__ + "img/c960.1da55318.1da55318.png";